import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { RegUser } from '../basic-reg/RegUser';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-platform-dynamics',
  standalone: true,
  templateUrl: './platform-dynamics.component.html',
  styleUrls: ['./platform-dynamics.component.scss'],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class PlatformDynamicsComponent implements OnInit {

  user: RegUser = new RegUser();
  LoggedIn: boolean = false;

  constructor(public authService: AuthServiceService, public global: Globals) { }

  ngOnInit(): void {
  }

  ionViewWillEnter() {    
    this.user = this.authService.getLoggedInUser();
    this.LoggedIn = this.authService.isLoggedIn();
    if (!this.global.isEmpty(this.user)) {
      this.user.imageUrl = this.authService.getProfilePicture() as string;
    }
  }

}
